import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useDebouncedAction } from "../../../../../../helpers/commonFunction";
import { AppState } from "../../../../../../stateManager/store";
import { getValue, getComponents } from "../../helpers";
import { onChange } from "./helpers/on-change"

const DEFAULT_PADDING: string = "properties.styles.$deviceType.padding";
const DEFAULT_PADDING_TOP = "properties.styles.$deviceType.paddingTop";
const DEFAULT_PADDING_RIGHT = "properties.styles.$deviceType.paddingRight";
const DEFAULT_PADDING_BOTTOM = "properties.styles.$deviceType.paddingBottom";
const DEFAULT_PADDING_LEFT = "properties.styles.$deviceType.paddingLeft";

type Props = {
  label?: string;
  isCheckedIn?: boolean;
  defaultValue?: string;
  isExpandPadding?: boolean;
}
export const Padding = (props: Props) => {
  const { components } = getComponents()
  const { selectedElementId, deviceType, isCoreV3, computedStyles } = useSelector((state: AppState) => state.formJson)
  const { isCheckedIn, defaultValue, label, isExpandPadding } = props;
  const [oldValue, setOldValue] = useState<string>("");
  const [value, setValue] = useDebouncedAction(defaultValue, 500);
  const component = components[selectedElementId];

  useEffect(() => {
    if (isCoreV3 && component) {
      const previousValue = getValue(component, DEFAULT_PADDING.split("."), deviceType);
      if (previousValue) {
        setValue(previousValue)
        setOldValue(previousValue)
      } else if (
        computedStyles.paddingTop === computedStyles.paddingRight &&
        computedStyles.paddingTop === computedStyles.paddingBottom &&
        computedStyles.paddingTop === computedStyles.paddingLeft
      ) {
        const overallPadding = parseInt(computedStyles.paddingTop).toString();
        setValue(overallPadding);
        setOldValue(overallPadding);
      } else {
        setValue("");
        setOldValue("");
      }
    }  else if (!isCoreV3 && component) {
      const previousValue = getValue(component, DEFAULT_PADDING.split("."), deviceType);
      if (previousValue) {
        setValue(previousValue)
        setOldValue(previousValue)
      }
    }
    // eslint-disable-next-line
  }, [getValue(component, DEFAULT_PADDING.split("."), deviceType), computedStyles]);

  return (
    <>
      <label
        htmlFor="Padding"
        className="panel-label"
      >
        {label}
      </label>
      <input
        style={{ cursor: !isCheckedIn || isExpandPadding ? "not-allowed" : "auto", width: "140px" }}
        disabled={!isCheckedIn || isExpandPadding}
        data-test-id={`${component?.type}-overall_padding`}
        type="number"
        id="Padding"
        value={value}
        className="panel-input"
        placeholder="0"
        onChange={e => {
          const value = e.target.value;
          setValue(value, () => onChange({
            path: DEFAULT_PADDING,
            value,
            oldValue,
            setOldValue,
            selectedElementId
          }))
        }}
      />
    </>
  )
};


export const PaddingTop = (props: Props) => {
  const { components } = getComponents()
  const { selectedElementId, deviceType, isCoreV3, computedStyles } = useSelector((state: AppState) => state.formJson)
  const { defaultValue } = props;
  const [oldValue, setOldValue] = useState<string>("");
  const [value, setValue] = useDebouncedAction(defaultValue, 500);
  const component = components[selectedElementId];

  useEffect(() => {
    if (isCoreV3 && component) {
      const previousValue = getValue(component, DEFAULT_PADDING_TOP.split("."), deviceType);
      if (previousValue) {
        setValue(previousValue)
        setOldValue(previousValue)
      } else if (computedStyles.paddingTop) {
        const computedValue = parseInt(computedStyles.paddingTop, 10).toString();
        setValue(computedValue)
        setOldValue(computedValue)
      }
    } else if (component) {
      const previousValue = getValue(component, DEFAULT_PADDING_TOP.split("."), deviceType);
      if (previousValue) {
        setValue(previousValue)
        setOldValue(previousValue)
      }
    }
    // eslint-disable-next-line
  }, [getValue(component, DEFAULT_PADDING_TOP.split("."), deviceType), computedStyles]);

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
        height: "28px",
        width: "34px",
        border: "2px solid #7D84924D",
        borderRadius: "2px",
        borderTopRightRadius: "3.5px",
        borderTopLeftRadius: "3.5px",
        borderTop: "none",
        marginLeft: "7px"
      }}
    >
      <input
        type="number"
        data-test-id={`${component?.type}-padding_top`}
        id="paddingtop"
        style={{
          position: "absolute",
          height: "28px",
          width: "34px",
          borderWidth: "2.3px",
          borderTopColor: (value && value != 0) ? "rgba(241, 114, 46, 1)" : "#052f35 ",
          borderStyle: "solid",
          borderLeft: "none",
          borderRadius: "4px",
          borderRight: "none",
          borderBottom: "none",
          background: "none",
          outline: "none",
        }}
        className="text-gray-900 text-lg p-2 text-center dark:text-white focus:outline-none cursor-pointer"
        placeholder="0"
        min={0}
        value={value}
        onChange={e => {
          const value = e.target.value;
          setValue(value, () => onChange({
            path: DEFAULT_PADDING_TOP,
            value,
            oldValue,
            setOldValue,
            selectedElementId
          }))
        }}
      />
    </div>
  )
}

export const PaddingRight = (props: Props) => {
  const { components } = getComponents()
  const { selectedElementId, deviceType, isCoreV3, computedStyles } = useSelector((state: AppState) => state.formJson)
  const { defaultValue } = props;
  const [oldValue, setOldValue] = useState<string>("");
  const [value, setValue] = useDebouncedAction(defaultValue, 500);
  const component = components[selectedElementId];

  useEffect(() => {
    if (isCoreV3 && component) {
      const previousValue = getValue(component, DEFAULT_PADDING_RIGHT.split("."), deviceType);
      if (previousValue) { 
        setValue(previousValue)
        setOldValue(previousValue)
      } else if (computedStyles.paddingRight) {
        const computedValue = parseInt(computedStyles.paddingRight, 10).toString();
        setValue(computedValue)
        setOldValue(computedValue)
      }
    } else if (!isCoreV3 && component) {
      const previousValue = getValue(component, DEFAULT_PADDING_RIGHT.split("."), deviceType);
      if (previousValue) {
        setValue(previousValue)
        setOldValue(previousValue)
      }
    }
    // eslint-disable-next-line
  }, [getValue(component, DEFAULT_PADDING_RIGHT.split("."), deviceType), computedStyles]);

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
        height: "28px",
        width: "34px",
        border: "2px solid #7D84924D",
        borderRadius: "2px",
        borderTopRightRadius: "3.5px",
        borderBottomRightRadius: "3.5px",
        borderRight: "none",
        marginLeft: "7px"
      }}
    >
      <input
        type="number"
        min={0}
        id="paddingright"
        data-test-id={`${component?.type}-padding_right`}
        style={{
          position: "absolute", left: "-2px",
          height: "28px",
          width: "34px",
          borderWidth: "2.3px",
          borderStyle: "solid",
          borderRadius: "4px",
          borderRightColor: (value && value != 0) ? "rgba(241, 114, 46, 1)" : "#052f35 ",
          borderBottom: "none",
          borderLeftWidth: "2.3px",
          borderLeftColor: "transparent",
          background: "none",
          borderTop: "none",
          outline: "none",
        }}
        className="text-gray-900 text-lg p-2 text-center dark:text-white focus:outline-none cursor-pointer"
        placeholder="0"
        value={value}
        onChange={e => {
          const value = e.target.value;
          setValue(value, () => onChange({
            path: DEFAULT_PADDING_RIGHT,
            value,
            oldValue,
            setOldValue,
            selectedElementId
          }))
        }}
      />
    </div>
  )
}

export const PaddingBottom = (props: Props) => {
  const { components } = getComponents()
  const { selectedElementId, deviceType, isCoreV3, computedStyles } = useSelector((state: AppState) => state.formJson)
  const { defaultValue } = props;
  const [oldValue, setOldValue] = useState<string>("");
  const [value, setValue] = useDebouncedAction(defaultValue, 500);
  const component = components[selectedElementId];

  useEffect(() => {
    if (isCoreV3 && component) {
      const previousValue = getValue(component, DEFAULT_PADDING_BOTTOM.split("."), deviceType);
      if (previousValue) {
        setValue(previousValue)
        setOldValue(previousValue)
      } else if (computedStyles.paddingBottom) {
        const computedValue = parseInt(computedStyles.paddingBottom, 10).toString();
        setValue(computedValue)
        setOldValue(computedValue)
      }
    } else if (!isCoreV3 && component) {
      const previousValue = getValue(component, DEFAULT_PADDING_BOTTOM.split("."), deviceType);
      setValue(previousValue)
      setOldValue(previousValue)
    }
    // eslint-disable-next-line
  }, [getValue(component, DEFAULT_PADDING_BOTTOM.split("."), deviceType), computedStyles]);

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
        height: "28px",
        width: "34px",
        border: "2px solid #7D84924D",
        borderRadius: "2px",
        borderBottomRightRadius: "3.5px",
        borderBottomLeftRadius: "3.5px",
        borderBottom: "none",
        marginLeft: "7px"
      }}
    >
      <input
        type="number"
        min={0}
        id="paddingbottom"
        data-test-id={`${component?.type}-padding_bottom`}
        style={{
          position: "absolute", left: "-1.5px",
          height: "28px",
          width: "34px",
          borderWidth: "2.3px",
          borderStyle: "solid",
          borderRadius: "4px",
          borderBottomColor: (value && value != 0) ? "rgba(241, 114, 46, 1)" : "#052f35 ",
          borderRight: "none",
          borderTopWidth: "2.3px",
          borderTopColor: "transparent",
          borderLeft: "none",
          background: "none",
          outline: "none",
        }}
        className="text-gray-900 text-lg p-2 text-center dark:text-white focus:outline-none cursor-pointer"
        placeholder="0"
        value={value}
        onChange={e => {
          const value = e.target.value;
          setValue(value, () => onChange({
            path: DEFAULT_PADDING_BOTTOM,
            value,
            oldValue,
            setOldValue,
            selectedElementId
          }))
        }}
      />
    </div>
  )
}

export const PaddingLeft = (props: Props) => {
  const { components } = getComponents()
  const { selectedElementId, deviceType, isCoreV3, computedStyles } = useSelector((state: AppState) => state.formJson)
  const { defaultValue } = props;
  const [oldValue, setOldValue] = useState<string>("");
  const [value, setValue] = useDebouncedAction(defaultValue, 500);
  const component = components[selectedElementId];

  useEffect(() => {
    if (isCoreV3 && component) {
      const previousValue = getValue(component, DEFAULT_PADDING_LEFT.split("."), deviceType);
      if (previousValue) {
        setValue(previousValue)
        setOldValue(previousValue)
      } else if (computedStyles.paddingLeft) {
        const computedValue = parseInt(computedStyles.paddingLeft, 10).toString();
        setValue(computedValue)
        setOldValue(computedValue)
      }
    } else if (!isCoreV3 && component) {
      const previousValue = getValue(component, DEFAULT_PADDING_LEFT.split("."), deviceType);
      setValue(previousValue)
      setOldValue(previousValue)
    }
    // eslint-disable-next-line
  }, [getValue(component, DEFAULT_PADDING_LEFT.split("."), deviceType), computedStyles]);

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
        height: "28px",
        width: "34px",
        border: "2px solid #7D84924D",
        borderRadius: "2px",
        borderTopLeftRadius: "3.5px",
        borderBottomLeftRadius: "3.5px",
        borderLeft: "none",
        marginLeft: "7px"
      }}
    >
      <input
        type="number"
        min={0}
        id="paddingleft"
        data-test-id={`${component?.type}-padding_left`}
        style={{
          position: "absolute",
          height: "28px",
          width: "34px",
          borderWidth: "2.3px",
          borderStyle: "solid",
          borderRadius: "4px",
          borderLeftColor: (value && value != 0) ? "rgba(241, 114, 46, 1)" : "#052f35 ",
          borderBottom: "none",
          borderRightWidth: "2.3px",
          borderRightColor: "transparent",
          background: "none",
          borderTop: "none",
          outline: "none",
        }}
        className="text-gray-900 text-lg p-2 text-center dark:text-white focus:outline-none cursor-pointer"
        placeholder="0"
        value={value}
        onChange={e => {
          const value = e.target.value;
          setValue(value, () => onChange({
            path: DEFAULT_PADDING_LEFT,
            value,
            oldValue,
            setOldValue,
            selectedElementId
          }))
        }}
      />
    </div>
  )
}